export default {"src":"/_next/static/media/financial-report-circle-dollar.ade78c0f.svg","height":106,"width":106,"blurWidth":0,"blurHeight":0};